import { useAutoAnimate } from "@formkit/auto-animate/react";

import type { MinimalCardType } from "~/types/card";
import { CollectionListTeaserVariant } from "./CollectionListPendingVariant";

export const CollectionListPendingCard = ({
  card,
  onChange,
}: {
  card: MinimalCardType;
  onChange: (vId: string, quantity: number) => void;
}) => {
  const [parent] = useAutoAnimate();
  return (
    <td className="flex select-none flex-col" ref={parent}>
      <div className={"flex h-[20px] flex-row items-center"}>
        <span className="inline-block w-[30px] px-2">
          {card.variants.reduce(
            (acc, v) =>
              acc + ((v as MinimalCardType["variants"][0] & { quantity?: number }).quantity ?? 1),
            0,
          )}
        </span>
        {card.name}
      </div>

      {card.variants.map((v) => (
        <CollectionListTeaserVariant
          key={v.id}
          variant={v as MinimalCardType["variants"][0] & { quantity?: number }}
          onChange={onChange}
        />
      ))}
    </td>
  );
};
